import { IErrorMapModule } from 'tag/ts/tag/interfaces/config/error/IErrorMapModule';

/**
 * @description Error code to error message ID map per player
 * @see {@link https://docs.google.com/spreadsheets/d/1nRjddK59TdxonFr5qBf2_ZLx6OVfVS6xSkCrT0XpPzk/edit#gid=1837910643}
 */
export const ErrorCodeMap: IErrorMapModule = {

	// Default error code
	DEFAULT: '1', // TODO: is this the right code?

	// INFO: SmartTag error codes: START

	// Unsupported browser
	'100': '100',
	// Dependency load failure
	'110': '110',
	// IMA load failed - Possible Ad Blocker
	'111': '111',
	// IMA load failed - Possible FF private mode
	'112': '112',
	// Ad blocker cbs.com ANON user up-sell
	'113': '113',
	// Ad blocker cbs.com LC user up-sell
	'114': '114',
	// Metadata load error - from page
	'120': '110',
	// Metadata load error - from CAN service
	'121': '110',
	// Metadata: Service not allowed
	'122': '110',
	// Metadata: no encode found
	'123': '110',
	// MPX call: non 2xx call (i.e. 404)
	'124': '110',
	// MPX call: API returned invalid XML data
	'125': '110',
	// RCO null
	'200': '110',
	// Container not found during Tag initialization
	'130': '130',
	// Tag initialization failure
	'131': '131',
	// tag.API.VIDEO.load() blocked — no usable JWT for a Stitcher load
	'132': '132',

	// INFO: SmartTag error codes: END

	// INFO: VTG player error codes START

	// RESOURCE_ERROR
	// INVALID_RESOURCE_FORMAT - Resource validation error, retrieval error/CMS error
	'1000': '1',
	// RESOURCE_ERROR
	// RESOURCE_UNAVAILABLE - MPX: 404
	'1100': '1',
	// RESOURCE_ERROR
	// GEO_LOCATION_BLOCKED - MPX: Geo-restricted content
	'1101': '3',
	// RESOURCE_ERROR
	// DOMAIN_BLOCKED - MPX: Domain is blocked from content access
	'1102': '2',
	// RESOURCE_ERROR
	// IP_BLOCKED - MPX: IP is blocked from content access
	'1103': '2',
	// RESOURCE_ERROR
	// SATELLITE_PROVIDER_BLOCKED - MPX: Provider is blocked from content access
	'1104': '2',
	// RESOURCE_ERROR
	// EXPIRED  - MPX: Content is no longer available
	'1105': '1',
	// RESOURCE_ERROR
	// SELECTOR_CALL_ERROR  - MPX: No response received; typically a failed XHR call with no explicit error
	'1106': '1',
	// RESOURCE_ERROR
	// IMA_SDK_MISSING - The SDK is either absent or its loading has been blocked.
	'1200': '5',
	// RESOURCE_ERROR
	// DAI_SDK_MISSING - The SDK is either absent or its loading has been blocked.
	'1201': '5',
	// RESOURCE_ERROR
	// DASH_SDK_MISSING - Dash low level streaming engine code is not compiled into VTG player.
	// It is loaded "just in time" If this load fails, it is fatal and this error will be thrown, playback will fail.
	'1202': '1',
	// RESOURCE_ERROR
	// HLS_SDK_MISSING - HLS low level streaming engine code is not compiled into VTG player.
	// It is loaded "just in time". If this load fails, it is fatal and this error will be thrown, playback will fail.
	'1203': '1',
	// VIDEO_START_ERROR
	// DYNAMIC_VARIANT_MANIFEST_PARSE_ERROR
	'2000': '1',
	// VIDEO_START_ERROR
	// HLSJS_PARSE_ERROR - HLS low level lib can not parse the manifest for some reason.  This error is fatal and playback will stop
	'2100': '1',
	// VIDEO_START_ERROR
	// DASHJS_PARSE_ERROR - DASH low level lib can not parse the manifest for some reason. This error is fatal and playback will stop
	'2200': '1',
	// VIDEO_START_ERROR
	// USER_GESTURE_REQUIRED - Video.play() invoked illegally when a user click is required to initiate play
	'2300': '1',
	// VIDEO_PLAYBACK_ERROR
	// HTML5_NETWORK_ERROR (MEDIA_ERR_NETWORK) - Native HTML5 playback network error of any type.  Could not download something needed for playback
	// Retry logic will not be performed for HTML5 playback. The HTML5 version of this error will indicate that it is either IOS, Safari using Fairplay or when forceHTML5 is true, Android only when forceHTML5 is true.
	'3001': '4',
	// VIDEO_PLAYBACK_ERROR
	// HLSJS_NETWORK_ERROR - HLS low level lib network error.  Could not download something needed for playback-
	// Retry logic will be performed based on playbackSettings.recovery.networkRetryAttempts
	'3002': '4',
	// VIDEO_PLAYBACK_ERROR
	// DASHJS_NETWORK_ERROR - DASH low level lib network error.  Could not download something needed for playback-
	// Retry logic will be performed based on playbackSettings.recovery.networkRetryAttempts
	'3003': '4',
	// VIDEO_PLAYBACK_ERROR
	// WEBMAF_NETWORK_ERROR - WEBMAF low level lib network error.  Could not download something needed for playback-
	// Retry logic will be performed based on playbackSettings.recovery.networkRetryAttempts
	'3004': '4',
	// VIDEO_PLAYBACK_ERROR
	// MEDIA_ABORTED (core video element error across all libs) - The fetching process for the media resource was aborted by the user agent at the user's request.
	'3100': '4',
	// VIDEO_PLAYBACK_ERROR
	// HTML5_SRC_NOT_SUPPORTED (core video element error) - Native HTML5 media resource was not suitable. Will be thrown when codecs, or mime types in
	// manifest are not supported by the player.  This is fatal and will stop playback with no retry attempts.  The HTML5 version of this error will indicate that
	// it is  either IOS, Safari using Fairplay or when forceHTML5Playback is true, Android only when forceHTML5Playback is true
	'3101': '4',
	// VIDEO_PLAYBACK_ERROR
	// HLSJS_SRC_NOT_SUPPORTED - HLS low media resource was not suitable. Will be thrown when codecs, or mime types in manifest
	// are not supported by the MSE layer.  This is fatal and will stop playback with no retry attempts
	'3102': '4',
	// VIDEO_PLAYBACK_ERROR
	// DASHJS_SRC_NOT_SUPPORTED - DASH low level lib media resource was not suitable. Will be thrown when codecs, or
	// mime types in manifest are not supported by the MSE layer.  This is fatal and will stop playback with no retry attempts
	'3103': '4',
	// VIDEO_PLAYBACK_ERROR
	// WEBMAF_SRC_NOT_SUPPORTED - WEBMAF low level lib media resource was not suitable. Will be thrown when codecs,
	// or mime types in manifest are not supported by the webmaf layer.  This is fatal and will stop playback with no retry attempts
	'3104': '4',
	// VIDEO_PLAYBACK_ERROR
	// HTML5_MEDIA_ERROR (core video element error) - Native HTML5 media error.  An error occurred while decoding the media
	// resource, after the resource was established to be usable. Thrown when corrupted chunks of media are encountered.
	// This is fatal and will stop playback with no retry attempts..  The HTML5 version of this error will indicate that it is
	// either IOS, Safari using Fairplay or when forceHTML5Playback is true, Android only when forceHTML5Playback is true
	'3200': '4',
	// VIDEO_PLAYBACK_ERROR
	// HLSJS_MEDIA_ERROR - HLS low level lib media error.  An error occurred while decoding the media resource, after
	// the resource was established to be usable.  Will be thrown when corrupted or un-playback chunks of media are
	// appended to the buffer, when buffer quota is exceeded or any other reason it could not append a chunk to the MSE buffer.
	// With HLS lib there is a recovery option. Retry logic will be performed based on playbackSettings.recovery.mediaRetryAttempts
	'3201': '4',
	// VIDEO_PLAYBACK_ERROR
	// HLSJS_MUX_ERROR * - HLS low level lib trans-muxing error.  Will be thrown when there is an issue with the trans-mux from TS segment to ISOBMFF segment.
	// This is fatal and will stop playback.
	'3202': '4',
	// VIDEO_PLAYBACK_ERROR
	// DASHJS_MEDIA_ERROR - DASH low level lib media error.   An error occurred while decoding the media resource, after the resource was established to be usable.
	// Will be thrown when corrupted or un-playback chunks of media are appended to the buffer, when buffer quota is exceeded or any other reason it could not
	// append a chunk to the MSE buffer.  With DASH lib there is a recovery option. Retry logic will be performed based on playbackSettings.recovery.mediaRetryAttempts
	'3203': '4',
	// VIDEO_PLAYBACK_ERROR
	// WEBMAF_MEDIA_ERROR - WEBMAF low level lib media error.   An error occurred while decoding the media resource, after the resource was established to be usable.
	'3204': '4',
	// VIDEO_PLAYBACK_ERROR
	// FAIRPLAY_APP_CERT_ERROR - Fairplay DRM error when issue is found with the App cert url, request or certificate decoding
	'3300': '4',
	// VIDEO_PLAYBACK_ERROR
	// FAIRPLAY_LIC_ERROR - Fairplay DRM error when issue is found with the License Server url, request or license.
	'3301': '4',
	// VIDEO_PLAYBACK_ERROR
	// DASHJS_DRM_ERROR - Widevine or Playready - Can be any reason DRM failed during the initialization of DRM for Dash.
	// Usually LA server issues or Key system not found, either wrong DRM flavor for browser or non HTTPS protocol
	'3302': '4',
	// VIDEO_PLAYBACK_ERROR
	// WEBMAF_DRM_ERROR - Some Issue with sony webmaf DRM for playready.
	'3303': '4',
	// Playready DRM error.
	// Thrown for any reason DRM failed during the initialization process.
	// Retry logic is not performed.
	// This error is fatal and playback will not begin.
	'3304': '4',
	// VIDEO_PLAYBACK_ERROR
	// UNSPECIFIED_VIDEO_PLAYBACK_ERROR - All other HTML5 Video errors or any unknown error.
	'3400': '4',
	// VIDEO_PLAYBACK_ERROR
	// UNSPECIFIED_HLSJS_ERROR - All other HLS low level lib video errors
	'3401': '4',
	// VIDEO_PLAYBACK_ERROR
	// UNSPECIFIED_DASHJS_ERROR - All other Dash low level lib video errors
	'3402': '4',
	// VIDEO_PLAYBACK_ERROR
	// UNSPECIFIED_PS4_ERROR - All other webmaf low level lib video errors
	'3403': '4',
	// AD_ERROR
	// AD_STALLED - Applies to IMA only; if ad progress fails to advance for period of 5 seconds, the ad is considered 'stalled',
	// the ad break is discarded and content play resumes if applicable.
	'4000': '1',
	// AD_ERROR
	// IMA_INIT_FAILURE - An attempt to initialize the IMA AdsManager object resulted in an error. In this case, no ads will play for the session.
	// This is a rare error.
	'4100': '1',
	// AD_ERROR
	// IMA_AD_ERROR - An error from the IMA SDK. There are numerous causes for an ad error; the AdErrorEvent emitted by
	// the JS player can be interrogated for details.
	'4101': '1',
	// AD_ERROR
	// DAI_DATA_ERROR - The DAI response is not interpretable or is missing critical data.
	'4200': '1',
	// AD_ERROR
	// DAI_NETWORK_ERROR - A response was not received from the DAI back end.
	'4201': '1',
	// AD_BLOCKED
	// AD_BLOCKING_DETECTED
	'4300': '5',
	// UNEXPECTED_CONDITION - Cases of developer error or other errors that do not fall into a well-described category
	'9999': '4'

	// INFO: VTG player error codes END

};